// extracted by mini-css-extract-plugin
export default {"adminBanner":"AdminHeader_adminBanner__OHgpZ"};